import React, { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import config from '../../config'
import { Row, Col, Table, Button, Form, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import Cookies from 'js-cookie'
import callapi from '../../helpers/callapi'
import Swal from 'sweetalert2'

const BoxOptionsModal = (props) => {
  const { isShowImportBox, setIsShowImportBox, isShowCountTemp, setIsShowCountTemp } = props
  const [amount, setAmount] = useState(0)
  const [dataBox, setDataBox] = useState({
    amount: 0,
    ugly: {},
    pretty: {},
  })
  const [countLotteries, setCountLotteries] = useState(0)
  const [lotteries, setLotteries] = useState({
    ugly: {},
    pretty: {},
  })
  const [countTempJson, setCountTempJson] = useState({})

  const dispatch = useDispatch()

  const fetchCountTemp = async () => {
    try {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/lotteries/count`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        })

        const countTemp = await response.json()
        if (countTemp.status.code !== 0) {
          Swal.fire({
            title: 'Error count lotteries temp',
            text: 'กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
          })
          setIsShowImportBox(false)
        }
        setCountTempJson(countTemp)
        setLotteries(countTemp.data.box)
      } catch {
        Swal.fire({
          title: 'พบข้อผิดพลาดกรุณาลองใหม่',
          text: 'กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
        })
        setIsShowImportBox(false)
      }
    } catch {
      Swal.fire({
        title: 'พบข้อผิดพลาดกรุณาลองใหม่',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
      setIsShowImportBox(false)
    }
  }

  useEffect(() => {
    fetchCountTemp()
  }, [])

  const createDataForBox = (type, serie) => {
    let cDataBox = { ...dataBox }
    if (cDataBox[type][serie]) {
      cDataBox[type][serie] += 1
    } else {
      cDataBox[type][serie] = 1
    }

    //นับจำนวน lotteries ในกล่อง
    let count = 0
    Object.keys(cDataBox.ugly).map((serie) => {
      count += serie * cDataBox.ugly[serie]
    })
    Object.keys(cDataBox.pretty).map((serie) => {
      count += serie * cDataBox.pretty[serie]
    })
    setCountLotteries(count)
    setDataBox(cDataBox)
  }

  const clearDataForBox = () => {
    setCountLotteries(0)
    setDataBox({
      amount: 0,
      ugly: {},
      pretty: {},
    })
    setAmount(0)
  }

  const createBox = async () => {
    if (amount > 0 && amount <= 3000) {
      let cDataBox = { ...dataBox }
      cDataBox.amount = parseInt(amount)
      dispatch({ type: 'loading_show' })
      try {
        await axios.post(`${config.apiAdminGateway}/api/v1/admin/publish/mysterybox/general`, cDataBox, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        })
        alert('สร้างกล่องแล้ว')
      } catch (e) {
        console.log(e)
        alert(JSON.stringify(e))
      }
      fetchCountTemp()
      clearDataForBox()
      dispatch({ type: 'loading_hide' })
    } else {
      alert('จำนวนกล่องต้องมากกว่า 0 กล่อง และ ไม่เกิน 3000 กล่อง')
    }
  }

  return (
    <Fragment>
      <Modal size="l" show={isShowCountTemp} onHide={() => setIsShowCountTemp(false)}>
        <Modal.Header>
          <h3>นับยอดหวยใน Temp</h3>
          <Button variant="" className="close" onClick={() => setIsShowCountTemp(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row className="p-5">
            <div className="p-5">
              <pre id="count-temp-response-json">{JSON.stringify(countTempJson, null, 2)}</pre>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal size="xxl" show={isShowImportBox} onHide={() => setIsShowImportBox(false)}>
        <Modal.Header>
          <h3>ยืนยันเอากล่องเข้าระบบ</h3>
          <Button variant="" className="close" onClick={() => setIsShowImportBox(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="text-center">
              <h3 className="bg-warning py-4 rounded">ชนิดเลขชุด</h3>
              <Row>
                <Col>
                  <p className="text-danger">ชุดพอใช้</p>
                  <Table>
                    <thead>
                      <tr>
                        <th>ชุด</th>
                        <th>จำนวน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(lotteries.ugly).map((key, index) => {
                        const types = Object.keys(dataBox.ugly)
                        let remain =
                          amount > 0 && dataBox.ugly[key] && lotteries.ugly[key] - dataBox.ugly[key] * parseInt(amount)
                        if (remain === 0) {
                          remain = String(remain)
                        }
                        return (
                          <tr key={index}>
                            <td>{key}</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-end">
                                {lotteries.ugly[key]}&nbsp;
                                <span style={{ color: 'red' }}>
                                  {types.find((el) => el === key) && `(${remain || lotteries.ugly[key]})`}
                                </span>
                                <Button variant="danger" className="ml-5" onClick={() => createDataForBox('ugly', key)}>
                                  +
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </Col>
                <Col>
                  <p className="text-success ">ชุดดี</p>
                  <Table>
                    <thead>
                      <tr>
                        <th>ชุด</th>
                        <th>จำนวน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(lotteries.pretty).map((key, index) => {
                        const types = Object.keys(dataBox.pretty)
                        let remain =
                          amount > 0 &&
                          dataBox.pretty[key] &&
                          lotteries.pretty[key] - dataBox.pretty[key] * parseInt(amount)
                        if (remain === 0) {
                          remain = String(remain)
                        }
                        return (
                          <tr key={index}>
                            <td>{key}</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-end">
                                {lotteries.pretty[key]}&nbsp;
                                <span style={{ color: 'red' }}>
                                  {types.find((el) => el === key) && `(${remain || lotteries.pretty[key]})`}
                                </span>
                                <Button
                                  variant="success"
                                  className="ml-5"
                                  onClick={() => createDataForBox('pretty', key)}
                                >
                                  +
                                </Button>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
            <Col className="text-center">
              <h3 className="bg-warning py-4 rounded">กำหนดเลขชุดเข้ากล่อง</h3>
              <Row>
                <Col>
                  <p className="text-info">จำนวนเลขชุดที่เลือก</p>
                  {Object.keys(dataBox.ugly).map((serie, index) => {
                    return (
                      <div key={index} className="d-flex justify-content-between">
                        <div className="text-danger">ชุด {serie} ใบ</div>
                        <div>จำนวน {dataBox.ugly[serie]} ชุด</div>
                      </div>
                    )
                  })}
                  {Object.keys(dataBox.pretty).map((serie, index) => {
                    return (
                      <div key={index} className="d-flex justify-content-between">
                        <div className="text-success">ชุด {serie} ใบ</div>
                        <div>จำนวน {dataBox.pretty[serie]} ชุด</div>
                      </div>
                    )
                  })}
                  {countLotteries > 0 && <div className="mt-5">จำนวนลอตเตอรี่ในกล่อง {countLotteries} ใบ</div>}
                  {countLotteries > 0 && (
                    <div>
                      <div className="text-left mb-5">
                        <Button variant="info light" onClick={() => clearDataForBox()}>
                          ล้างที่เลือก
                        </Button>
                      </div>
                      <div className="mt-5 text-left">
                        <Form.Group className="mb-2">
                          <Form.Text className="text-muted ml-1">จำนวนกล่องสุ่มที่ใช้สูตรนี้ในการสร้าง</Form.Text>
                          <Form.Control type="text" defaultValue="" onChange={(e) => setAmount(e.target.value)} />
                        </Form.Group>
                        <Button className="w-100 mt-0" onClick={() => createBox()}>
                          สร้าง
                        </Button>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex">
          <Button
            variant="danger light"
            onClick={() => {
              setIsShowImportBox(false)
            }}
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}

export default BoxOptionsModal
